// import React, { useEffect, useState, useCallback } from 'react';
// import {
//     Container, Spinner, Alert, Card, Row, Col, Button, Form, Table, Modal, Badge
// } from 'react-bootstrap';
// import { useNavigate } from 'react-router-dom';
// import {
//     getAllProductsForAdmin, approveProductAdmin, rejectProductAdmin, adminDeleteProduct,
//     getAllCompanyCategories, getAllCompanySubCategories
// } from '../../../services/adminService'; // Adjust path

// const AdminProductManagementPage = () => {
//     const [products, setProducts] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState('');
//     const [success, setSuccess] = useState('');
//     const navigate = useNavigate();

//     // Filters
//     const [statusFilter, setStatusFilter] = useState('');
//     const [companyNameFilter, setCompanyNameFilter] = useState('');

//     // Reject Modal state
//     const [showRejectModal, setShowRejectModal] = useState(false);
//     const [selectedProductForReject, setSelectedProductForReject] = useState(null);
//     const [rejectionReason, setRejectionReason] = useState('');
//     const [rejectLoading, setRejectLoading] = useState(false);

//     // Delete Modal state
//     const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
//     const [selectedProductForDelete, setSelectedProductForDelete] = useState(null);
//     const [deleteLoading, setDeleteLoading] = useState(false);

//     const fetchProducts = useCallback(async () => {
//         setLoading(true);
//         setError('');
//         setSuccess('');
//         try {
//             const token = localStorage.getItem('token');
//             if (!token) {
//                 setError("Please log in as an administrator to view this page.");
//                 navigate('/admin/login'); // Or appropriate admin login route
//                 return;
//             }

//             const filters = {};
//             if (statusFilter) filters.status = statusFilter;
           

//             const res = await getAllProductsForAdmin();
//             let fetchedProducts = res.data;

//             if (companyNameFilter) {
//                 fetchedProducts = fetchedProducts.filter(product =>
//                     product.company?.name.toLowerCase().includes(companyNameFilter.toLowerCase())
//                 );
//             }
//             setProducts(fetchedProducts);
//         } catch (err) {
//             console.error("Failed to fetch products:", err);
//             setError(err.response?.data?.message || err.message || "Failed to fetch products.");
//         } finally {
//             setLoading(false);
//         }
//     }, [navigate, statusFilter, companyNameFilter]);

//     useEffect(() => {
//         fetchProducts();
//     }, [fetchProducts]);

//     const getStatusBadgeVariant = (status) => {
//         switch (status) {
//             case 'approved': return 'success';
//             case 'pending': return 'warning';
//             case 'pending_update': return 'info';
//             case 'pending_delete': return 'danger'; // Highlight deletion requests
//             case 'rejected': return 'danger';
//             default: return 'secondary';
//         }
//     };

//     const handleApprove = async (productId) => {
//         setLoading(true); // Re-use main loading for action, or use separate state
//         setError('');
//         setSuccess('');
//         try {
//             const res = await approveProductAdmin(productId);
//             setSuccess(res.message);
//             await fetchProducts(); // Refresh the list
//         } catch (err) {
//             setError(err.response?.data?.message || err.message || "Failed to approve product.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleRejectClick = (product) => {
//         setSelectedProductForReject(product);
//         setRejectionReason('');
//         setShowRejectModal(true);
//     };

//     const handleRejectSubmit = async () => {
//         if (!rejectionReason.trim()) {
        
//             return;
//         }
//         setRejectLoading(true);
//         setError('');
//         setSuccess('');
//         try {
//             const res = await rejectProductAdmin(selectedProductForReject._id, rejectionReason);
//             setSuccess(res.message);
//             handleCloseRejectModal();
//             await fetchProducts(); // Refresh the list
//         } catch (err) {
//             setError(err.response?.data?.message || err.message || "Failed to reject product.");
//         } finally {
//             setRejectLoading(false);
//         }
//     };

//     const handleCloseRejectModal = () => {
//         setShowRejectModal(false);
//         setSelectedProductForReject(null);
//         setRejectionReason('');
//         setError(''); // Clear any modal-specific error
//     };

//     const handleDeleteClick = (product) => {
//         setSelectedProductForDelete(product);
//         setShowDeleteConfirmModal(true);
//     };

//     const handleDeleteConfirm = async () => {
//         setDeleteLoading(true);
//         setError('');
//         setSuccess('');
//         try {
//             const res = await adminDeleteProduct(selectedProductForDelete._id);
//             setSuccess(res.message);
//             handleCloseDeleteConfirmModal();
//             await fetchProducts(); // Refresh the list
//         } catch (err) {
//             setError(err.response?.data?.message || err.message || "Failed to delete product permanently.");
//         } finally {
//             setDeleteLoading(false);
//         }
//     };

//     const handleCloseDeleteConfirmModal = () => {
//         setShowDeleteConfirmModal(false);
//         setSelectedProductForDelete(null);
//         setError(''); // Clear any modal-specific error
//     };

//     // Note: A full "Edit Product" for admin would require another modal/page
//     // and a backend API that directly updates without setting status to 'pending_update'.
//     // For now, admin can only approve/reject company-initiated updates/creations/deletions.

//     return (
//         <Container className="py-5">
//             <h1 className="mb-4 text-center">Admin Product Management</h1>

//             {loading && <Alert variant="info" className="text-center"><Spinner animation="border" size="sm" /> Loading products...</Alert>}
//             {error && <Alert variant="danger">{error}</Alert>}
//             {success && <Alert variant="success">{success}</Alert>}

            
               

//             <Card className="shadow-sm">
//                 <Card.Header className="bg-primary text-white">All Products</Card.Header>
//                 <Card.Body>
//                     {products.length === 0 && !loading && <Alert variant="info">No products found matching your criteria.</Alert>}
//                     {products.length > 0 && (
//                         <div className="table-responsive">
//                             <Table striped bordered hover className="mt-3">
//                                 <thead>
//                                     <tr>
//                                         <th>#</th>
//                                         <th>Image</th>
//                                         <th>Name</th>
//                                         <th>Description</th>
//                                         <th>Company</th>
//                                         <th>Category</th>
//                                         <th>SubCategory</th>
//                                         <th>Status</th>
//                                         <th>Actions</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {products.map((product, index) => (
//                                         <tr key={product._id}>
//                                             <td>{index + 1}</td>
//                                             <td>
//                                                 {product.images && product.images.length > 0 ? (
//                                                     <img src={product.images[0]} alt={product.name} style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
//                                                 ) : (
//                                                     <img  alt="No Img" style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
//                                                 )}
//                                             </td>
//                                             <td>{product.name}</td>
//                                             <td>{product.description?.substring(0, 50)}...</td>
//                                             <td>{product.company?.name || 'N/A'}</td>
//                                             <td>{product.category?.name || 'N/A'}</td>
//                                             <td>{product.subCategory?.name || 'N/A'}</td>
//                                             <td>
//                                                 <Badge bg={getStatusBadgeVariant(product.status)}>
//                                                     {product.status?.replace(/_/g, ' ').toUpperCase()}
//                                                 </Badge>
//                                                 {product.rejectionReason && (
//                                                     <p className="text-danger small mt-1">Reason: {product.rejectionReason}</p>
//                                                 )}
//                                             </td>
//                                             <td>
//                                                 {product.status === 'pending' || product.status === 'pending_update' || product.status === 'pending_delete' ? (
//                                                     <Button variant="success" size="sm" className="me-2 mb-1" onClick={() => handleApprove(product._id)}>
//                                                         {product.status === 'pending_delete' ? 'Confirm Delete' : 'Approve'}
//                                                     </Button>
//                                                 ) : null}

//                                                 {product.status !== 'rejected' && product.status !== 'pending_delete' && ( // Can reject if not already rejected or awaiting deletion confirmation
//                                                     <Button variant="warning" size="sm" className="me-2 mb-1" onClick={() => handleRejectClick(product)}>
//                                                         Reject
//                                                     </Button>
//                                                 )}

//                                                 <Button variant="danger" size="sm" className="mb-1" onClick={() => handleDeleteClick(product)}>
//                                                     Delete Permanently
//                                                 </Button>
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </Table>
//                         </div>
//                     )}
//                 </Card.Body>
//             </Card>

//             {/* Reject Product Modal */}
//             <Modal show={showRejectModal} onHide={handleCloseRejectModal} centered>
//                 <Modal.Header closeButton>
//                     <Modal.Title>Reject Product</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     {error && <Alert variant="danger">{error}</Alert>}
//                     <p>Are you sure you want to reject "{selectedProductForReject?.name}"?</p>
//                     <Form.Group className="mb-3">
//                         <Form.Label>Reason for Rejection</Form.Label>
//                         <Form.Control
//                             as="textarea"
//                             rows={3}
//                             value={rejectionReason}
//                             onChange={(e) => setRejectionReason(e.target.value)}
//                             placeholder="Please provide a clear reason for rejection."
//                             required
//                         />
//                     </Form.Group>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button variant="secondary" onClick={handleCloseRejectModal} disabled={rejectLoading}>
//                         Cancel
//                     </Button>
//                     <Button variant="danger" onClick={handleRejectSubmit} disabled={rejectLoading || !rejectionReason.trim()}>
//                         {rejectLoading ? <Spinner as="span" animation="border" size="sm" /> : 'Reject Product'}
//                     </Button>
//                 </Modal.Footer>
//             </Modal>

//             {/* Delete Confirmation Modal */}
//             <Modal show={showDeleteConfirmModal} onHide={handleCloseDeleteConfirmModal} centered>
//                 <Modal.Header closeButton>
//                     <Modal.Title>Confirm Permanent Deletion</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     {error && <Alert variant="danger">{error}</Alert>}
//                     <Alert variant="danger">
//                         <strong>Warning:</strong> Are you sure you want to permanently delete "{selectedProductForDelete?.name}"?
//                         This action cannot be undone and will remove all associated images.
//                     </Alert>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button variant="secondary" onClick={handleCloseDeleteConfirmModal} disabled={deleteLoading}>
//                         Cancel
//                     </Button>
//                     <Button variant="danger" onClick={handleDeleteConfirm} disabled={deleteLoading}>
//                         {deleteLoading ? <Spinner as="span" animation="border" size="sm" /> : 'Delete Permanently'}
//                     </Button>
//                 </Modal.Footer>
//             </Modal>
//         </Container>
//     );
// };

// export default AdminProductManagementPage;

import React, { useEffect, useState, useCallback } from 'react';
import {
    Container, Spinner, Alert, Card, Row, Col, Button, Form, Table, Modal, Badge, Collapse
} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import {
    getAllProductsForAdmin, approveProductAdmin, rejectProductAdmin, adminDeleteProduct
} from '../../../services/adminService'; // Adjust path

const AdminProductManagementPage = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const navigate = useNavigate();

    // Filters
    const [statusFilter, setStatusFilter] = useState('');
    const [companyNameFilter, setCompanyNameFilter] = useState('');

    // Reject Modal state
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [selectedProductForReject, setSelectedProductForReject] = useState(null);
    const [rejectionReason, setRejectionReason] = useState('');
    const [rejectLoading, setRejectLoading] = useState(false);

    // Delete Modal state
    const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
    const [selectedProductForDelete, setSelectedProductForDelete] = useState(null);
    const [deleteLoading, setDeleteLoading] = useState(false);

    // State for managing collapsed/expanded company product lists
    const [expandedCompanies, setExpandedCompanies] = useState({}); // { companyId: true/false }

    const toggleCompanyExpansion = (companyId) => {
        setExpandedCompanies(prev => ({
            ...prev,
            [companyId]: !prev[companyId]
        }));
    };

    // const fetchProducts = useCallback(async (currentStatusFilter, currentCompanyNameFilter) => {
    //     setLoading(true);
    //     setError('');
    //     setSuccess('');
    //     try {
    //         const token = localStorage.getItem('token');
    //         if (!token) {
    //             setError("Please log in as an administrator to view this page.");
    //             navigate('/admin/login'); // Or appropriate admin login route
    //             return;
    //         }

    //         const res = await getAllProductsForAdmin();
    //         let fetchedProducts = res.data;

    //         // Apply client-side filtering based on provided arguments
    //         if (currentStatusFilter) {
    //             fetchedProducts = fetchedProducts.filter(product => product.status === currentStatusFilter);
    //         }
    //         if (currentCompanyNameFilter) {
    //             fetchedProducts = fetchedProducts.filter(product =>
    //                 product.company?.name.toLowerCase().includes(currentCompanyNameFilter.toLowerCase())
    //             );
    //         }
    //         setProducts(fetchedProducts);
    //     } catch (err) {
    //         console.error("Failed to fetch products:", err);
    //         setError(err.response?.data?.message || err.message || "Failed to fetch products.");
    //     } finally {
    //         setLoading(false);
    //     }
    // }, [navigate]);



const fetchProducts = useCallback(async (currentStatusFilter, currentCompanyNameFilter) => {
    setLoading(true);
    setError('');
    setSuccess('');
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            setError("Please log in as an administrator to view this page.");
            navigate('/admin/login');
            return;
        }

        const res = await getAllProductsForAdmin();
        let fetchedProducts = res.data;

        // ✅ Always exclude approved products
        fetchedProducts = fetchedProducts.filter(
            (product) => product.status !== 'approved'
        );

        // Apply filters if provided
        if (currentStatusFilter) {
            fetchedProducts = fetchedProducts.filter(product => product.status === currentStatusFilter);
        }
        if (currentCompanyNameFilter) {
            fetchedProducts = fetchedProducts.filter(product =>
                product.company?.name.toLowerCase().includes(currentCompanyNameFilter.toLowerCase())
            );
        }

        setProducts(fetchedProducts);
    } catch (err) {
        console.error("Failed to fetch products:", err);
        setError(err.response?.data?.message || err.message || "Failed to fetch products.");
    } finally {
        setLoading(false);
    }
}, [navigate]);


    useEffect(() => {
        // Initial fetch with current filter values
        fetchProducts(statusFilter, companyNameFilter);
    }, [fetchProducts]);

    const handleApplyFilters = () => {
        fetchProducts(statusFilter, companyNameFilter);
    };

    const handleClearFilters = () => {
        setStatusFilter('');
        setCompanyNameFilter('');
        // Immediately fetch with cleared filters
        fetchProducts('', ''); // Pass empty strings for cleared filters
    };

    // Group products by company
    const groupedProducts = products.reduce((acc, product) => {
        const companyId = product.company?._id;
        if (companyId) {
            if (!acc[companyId]) {
                acc[companyId] = {
                    companyInfo: product.company,
                    products: []
                };
            }
            acc[companyId].products.push(product);
        }
        return acc;
    }, {});


    const getStatusBadgeVariant = (status) => {
        switch (status) {
            case 'approved': return 'success';
            case 'pending': return 'warning';
            case 'pending_update': return 'info';
            case 'pending_delete': return 'danger'; // Highlight deletion requests
            case 'rejected': return 'danger';
            default: return 'secondary';
        }
    };

    const handleApprove = async (productId) => {
        setLoading(true);
        setError('');
        setSuccess('');
        try {
            const res = await approveProductAdmin(productId);
            setSuccess(res.message);
            await fetchProducts(statusFilter, companyNameFilter); // Refresh the list with current filters
        } catch (err) {
            setError(err.response?.data?.message || err.message || "Failed to approve product.");
        } finally {
            setLoading(false);
        }
    };

    const handleRejectClick = (product) => {
        setSelectedProductForReject(product);
        setRejectionReason('');
        setShowRejectModal(true);
    };

    const handleRejectSubmit = async () => {
        if (!rejectionReason.trim()) {
            setError("Rejection reason cannot be empty."); // Add modal-specific error
            return;
        }
        setRejectLoading(true);
        setError('');
        setSuccess('');
        try {
            const res = await rejectProductAdmin(selectedProductForReject._id, rejectionReason);
            setSuccess(res.message);
            handleCloseRejectModal();
            await fetchProducts(statusFilter, companyNameFilter); // Refresh the list with current filters
        } catch (err) {
            setError(err.response?.data?.message || err.message || "Failed to reject product.");
        } finally {
            setRejectLoading(false);
        }
    };

    const handleCloseRejectModal = () => {
        setShowRejectModal(false);
        setSelectedProductForReject(null);
        setRejectionReason('');
        setError(''); // Clear any modal-specific error
    };

    const handleDeleteClick = (product) => {
        setSelectedProductForDelete(product);
        setShowDeleteConfirmModal(true);
    };

    const handleDeleteConfirm = async () => {
        setDeleteLoading(true);
        setError('');
        setSuccess('');
        try {
            const res = await adminDeleteProduct(selectedProductForDelete._id);
            setSuccess(res.message);
            handleCloseDeleteConfirmModal();
            await fetchProducts(statusFilter, companyNameFilter); // Refresh the list with current filters
        } catch (err) {
            setError(err.response?.data?.message || err.message || "Failed to delete product permanently.");
        } finally {
            setDeleteLoading(false);
        }
    };

    const handleCloseDeleteConfirmModal = () => {
        setShowDeleteConfirmModal(false);
        setSelectedProductForDelete(null);
        setError(''); // Clear any modal-specific error
    };

    return (
        <Container className="py-5">
            <h1 className="mb-4 text-center">Admin Product Management</h1>

            {loading && <Alert variant="info" className="text-center"><Spinner animation="border" size="sm" /> Loading products...</Alert>}
            {error && <Alert variant="danger">{error}</Alert>}
            {success && <Alert variant="success">{success}</Alert>}

            {/* Filters Section */}
            <Card className="mb-4 shadow-sm">
                <Card.Header className="bg-light">Product Filters</Card.Header>
                <Card.Body>
                    <Form>
                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Group controlId="statusFilter">
                                    <Form.Label>Filter by Status</Form.Label>
                                    <Form.Control
                                        as="select"
                                        value={statusFilter}
                                        onChange={(e) => setStatusFilter(e.target.value)}
                                    >
                                        <option value="">All Statuses</option>
                                        <option value="approved">Approved</option>
                                        <option value="pending">Pending</option>
                                        <option value="pending_update">Pending Update</option>
                                        <option value="pending_delete">Pending Delete</option>
                                        <option value="rejected">Rejected</option>
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="companyNameFilter">
                                    <Form.Label>Filter by Company Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter company name"
                                        value={companyNameFilter}
                                        onChange={(e) => setCompanyNameFilter(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Button onClick={handleApplyFilters} className="mt-3">Apply Filters</Button>
                        <Button variant="secondary" onClick={handleClearFilters} className="mt-3 ms-2">Clear Filters</Button>
                    </Form>
                </Card.Body>
            </Card>

            {/* Grouped Products Display */}
            {Object.values(groupedProducts).length === 0 && !loading && <Alert variant="info">No products found matching your criteria.</Alert>}

            {Object.values(groupedProducts).length > 0 && (
                <div>
                    {Object.values(groupedProducts).map((companyGroup) => (
                        <Card key={companyGroup.companyInfo._id} className="mb-3 shadow-sm">
                            <Card.Header
                                className="bg-info text-white d-flex justify-content-between align-items-center"
                                style={{ cursor: 'pointer' }}
                                onClick={() => toggleCompanyExpansion(companyGroup.companyInfo._id)}
                            >
                                <h5>{companyGroup.companyInfo.name} ({companyGroup.products.length} Products)</h5>
                                <Button variant="outline-light" size="sm">
                                    {expandedCompanies[companyGroup.companyInfo._id] ? 'Collapse' : 'Expand'}
                                </Button>
                            </Card.Header>
                            <Collapse in={!!expandedCompanies[companyGroup.companyInfo._id]}>
                                <Card.Body>
                                    <div className="table-responsive">
                                        <Table striped bordered hover className="mt-3">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Image</th>
                                                    <th>Name</th>
                                                    <th>Description</th>
                                                    <th>Category</th>
                                                    <th>SubCategory</th>
                                                    <th>Status</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {companyGroup.products.map((product, index) => (
                                                    <tr key={product._id}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            {product.images && product.images.length > 0 ? (
                                                                <img src={product.images[0]} alt={product.name} style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
                                                            ) : (
                                                                <div style={{ width: '50px', height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #eee', fontSize: '0.7em', textAlign: 'center', background: '#f8f8f8' }}>
                                                                    No Image
                                                                </div>
                                                            )}
                                                        </td>
                                                        <td>{product.name}</td>
                                                        <td>{product.description?.substring(0, 50)}...</td>
                                                        <td>{product.category?.name || 'N/A'}</td>
                                                        <td>{product.subCategory?.name || 'N/A'}</td>
                                                        <td>
                                                            <Badge bg={getStatusBadgeVariant(product.status)}>
                                                                {product.status?.replace(/_/g, ' ').toUpperCase()}
                                                            </Badge>
                                                            {product.rejectionReason && (
                                                                <p className="text-danger small mt-1">Reason: {product.rejectionReason}</p>
                                                            )}
                                                        </td>
                                                        <td>
                                                            {product.status === 'pending' || product.status === 'pending_update' || product.status === 'pending_delete' ? (
                                                                <Button variant="success" size="sm" className="me-2 mb-1" onClick={() => handleApprove(product._id)}>
                                                                    {product.status === 'pending_delete' ? 'Confirm Delete' : 'Approve'}
                                                                </Button>
                                                            ) : null}

                                                            {product.status !== 'rejected' && product.status !== 'pending_delete' && ( // Can reject if not already rejected or awaiting deletion confirmation
                                                                <Button variant="warning" size="sm" className="me-2 mb-1" onClick={() => handleRejectClick(product)}>
                                                                    Reject
                                                                </Button>
                                                            )}

                                                            <Button variant="danger" size="sm" className="mb-1" onClick={() => handleDeleteClick(product)}>
                                                                Delete Permanently
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </Card.Body>
                            </Collapse>
                        </Card>
                    ))}
                </div>
            )}

            {/* Reject Product Modal */}
            <Modal show={showRejectModal} onHide={handleCloseRejectModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Reject Product</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error && <Alert variant="danger">{error}</Alert>}
                    <p>Are you sure you want to reject "{selectedProductForReject?.name}"?</p>
                    <Form.Group className="mb-3">
                        <Form.Label>Reason for Rejection</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={rejectionReason}
                            onChange={(e) => setRejectionReason(e.target.value)}
                            placeholder="Please provide a clear reason for rejection."
                            required
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseRejectModal} disabled={rejectLoading}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleRejectSubmit} disabled={rejectLoading || !rejectionReason.trim()}>
                        {rejectLoading ? <Spinner as="span" animation="border" size="sm" /> : 'Reject Product'}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteConfirmModal} onHide={handleCloseDeleteConfirmModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Permanent Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error && <Alert variant="danger">{error}</Alert>}
                    <Alert variant="danger">
                        <strong>Warning:</strong> Are you sure you want to permanently delete "{selectedProductForDelete?.name}"?
                        This action cannot be undone and will remove all associated images.
                    </Alert>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDeleteConfirmModal} disabled={deleteLoading}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDeleteConfirm} disabled={deleteLoading}>
                        {deleteLoading ? <Spinner as="span" animation="border" size="sm" /> : 'Delete Permanently'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};

export default AdminProductManagementPage;